import { FC, useState } from 'react';
import { Button } from 'antd';
import { CheckCircleOutlined, LinkOutlined } from '@ant-design/icons';
import Modal from 'react-modal';
import { ZINDEX_MODAL } from './AppConstants';
import { useAppState } from '../../state/AppState';

const InviteFriendsButton: FC = () => {
  const [modalIsOpen, setModalState] = useState(false);
  const { currentArea } = useAppState();

  const loc = `${window.location.href.split('?')[0]}?area=${currentArea}`;

  return (
    <>
      <Button style={{ width: 120 }} onClick={() => setModalState(true)}>
        invite friends
      </Button>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={(e) => {
          e.stopPropagation();
          setModalState(false);
        }}
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            background: 'white',
            border: 'none',
          },
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            zIndex: ZINDEX_MODAL,
          },
        }}>
        <div
          style={{
            minWidth: 300,
            paddingTop: 16,
            paddingLeft: 16,
            paddingRight: 16,
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center',
            justifyContent: 'center',
          }}>
          <h3 style={{ marginBottom: 16 }}>Send this link to invite a friend:</h3>
          <div
            style={{
              marginBottom: 24,
              textAlign: 'center',
              backgroundColor: '#efefef',
              padding: '10px 24px',
              color: 'black',
              borderRadius: 20,
            }}>
            {loc}
          </div>
          <div style={{ marginBottom: 24, textAlign: 'center' }}>
            <Button icon={<LinkOutlined />} onClick={() => navigator.clipboard.writeText(loc)}>
              Copy to clipboard
            </Button>
          </div>
          <Button
            style={{ color: 'black', alignSelf: 'flex-end' }}
            type='text'
            icon={<CheckCircleOutlined />}
            onClick={() => setModalState(false)}>
            Done
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default InviteFriendsButton;
